import React, { createContext, useContext, useState, useCallback } from 'react';
interface ErrorContextProps {
  error: string | null;
  setError: (message: string) => void;
  clearError: () => void;
  loading: boolean;
  setLoading: (state: boolean) => void;
}
// Usamos este hook de ErrorContext para los métodos POST y PUT
const ErrorContext = createContext<ErrorContextProps | undefined>(undefined);

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError debe ser usado dentro de ErrorProvider');
  }
  return context;
};

export const ErrorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return (
    <ErrorContext.Provider value={{ error, setError, clearError, loading, setLoading }}>
      {children}
    </ErrorContext.Provider>
  );
};
